export default "__VITE_ASSET__BWlRjopu__"